import React from 'react';
import classNames from 'classnames';

import css from './IconMasterCard.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} IconMasterCard icon
 */
const IconMasterCard = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="35"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#7DC0F4" />
      <path
        d="M22.1758 5C25.9444 5 29 8.09091 29 11.9033C28.9998 15.7156 25.9443 18.8057 22.1758 18.8057C20.4863 18.8056 18.9416 18.1832 17.75 17.1543C16.5584 18.1832 15.0137 18.8056 13.3242 18.8057C9.55566 18.8057 6.50018 15.7156 6.5 11.9033C6.5 8.09091 9.55555 5 13.3242 5C15.0134 5.00011 16.5584 5.62186 17.75 6.65039C18.9416 5.62186 20.4866 5.00011 22.1758 5Z"
        fill="#ED0006"
      />
      <path
        d="M22.1758 5C25.9444 5 29 8.09091 29 11.9033C28.9998 15.7156 25.9443 18.8057 22.1758 18.8057C20.4863 18.8056 18.9416 18.1832 17.75 17.1543C19.2164 15.8882 20.1474 14.0064 20.1475 11.9033C20.1475 9.79982 19.2168 7.91652 17.75 6.65039C18.9416 5.62186 20.4866 5.00011 22.1758 5Z"
        fill="#F9A000"
      />
      <path
        d="M17.749 6.65088C19.2157 7.917 20.1465 9.79949 20.1465 11.9028C20.1465 14.0059 19.2154 15.8877 17.749 17.1538C16.2827 15.8877 15.3516 14.0059 15.3516 11.9028C15.3516 9.79951 16.2824 7.917 17.749 6.65088Z"
        fill="#FF5E00"
      />
    </svg>
  );
};

export default IconMasterCard;
